import { requestServer } from "$lib/servers.svelte";
import { invalidateServerToken } from "$lib/auth.svelte";

export async function getPageCount(server: any, seriesId: string, title: string, num: string, subNum: string) {
  try {
    const { data, status } = await requestServer(
      server,
      'get',
      `api/v1/series/${seriesId}/read/count?vol=${title == 'volume' ? num : 0}&chp=${
        title == 'chapter' ? num : 0}&svol=${title == 'volume' ? subNum : 0}&schp=${
          title == 'chapter' ? subNum : 0}`,
      null
    )
    if (status == 401) throw { response: { status: 401 } }
    return data
  } catch (error) {
    if (error?.response?.status == 401) {
      invalidateServerToken(server.uid)
      return
    }
    console.log(error)
    return {}
  }
}

export async function getPageCountByBook(server: any, bookId: string) {
  try {
    const { data, status } = await requestServer(
      server,
      'get',
      `api/v1/read/${bookId}/count`,
      null
    )
    if (status == 401) throw { response: { status: 401 } }
    return data
  } catch (error) {
    if (error?.response?.status == 401) {
      invalidateServerToken(server.uid)
      return
    }
    console.log(error)
    return {}
  }
}

export async function getBookCover(server: any, bookId: string) {
  try {
    const { data, status } = await requestServer(
      server,
      'get',
      `api/v1/read/${bookId}/cover`,
      null
    )
    if (status == 401) throw { response: { status: 401 } }
    return data
  } catch (error) {
    if (error?.response?.status == 401) {
      invalidateServerToken(server.uid)
      return
    }
    console.log(error)
    return {}
  }
}
